<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col cols="4">
        <app-select-mapeamento
          :mapeamento="mapeamento"
          :mapeamentos="mapeamentos"
          @return="(value) => (mapeamento = value)"
        />
      </v-col>
    </v-row>
    <v-card-widget title="Dashboard">
      <div
        v-if="!mapeamento"
        slot="widget-content"
      >
        <app-alert
          type="info"
          message="Não há mapeamentos disponíveis."
        />
      </div>
      <div
        v-else
        slot="widget-content"
      >
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppAlert from '@/components/core/AppAlert';
import AppSelectMapeamento from '@/components/core/AppSelectMapeamento';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardMonitoramentoMapeamento',

  components: {
    VCardWidget,
    AppSelectMapeamento,
    AppAlert,
    AppTimeline,
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
    ...mapGetters({
      getMapeamento: 'mapeamento/getMapeamento',
      getMapeamentos: 'mapeamento/getMapeamentos',
    }),
    mapeamento: {
      get() {
        return this.getMapeamento(this.acesso);
      },
      set(mapeamento) {
        const payload = { tipo: this.acesso, mapeamento };
        this.$store.dispatch('mapeamento/setMapeamento', payload);
      },
    },
    mapeamentos() {
      return this.getMapeamentos(this.acesso);
    },
    acesso() {
      if (this.comissao) {
        return 'COMISSAO';
      }
      if (this.chefia || this.substituicaoChefia) {
        return 'COMUM';
      }
      return '';
    },
    inicioComportamental() {
      // Quando o mapeamento é importado inicioPerComportServidor é null
      return this.mapeamento.inicioPerComportServidor
        ? this.mapeamento.inicioPerComportServidor : this.mapeamento.inicioPerComportComissao;
    },
    timelineItens() {
      return [
        {
          visibilidade: true,
          titulo: 'Estrutura das Unidades',
          textos: [
            'Como Gestor você pode analisar a(s) estrutura(s) da sua unidade.',
          ],
          icone: 'diversity_3',
          link: '/monitoramento/mapeamento/estrutura-unidades',
          dataInicial: this.inicioComportamental,
          dataFinal: this.mapeamento.fimPerComportComissao,
        },
        {
          visibilidade: true,
          titulo: 'Mapeamento comportamental (perspectiva comportamental)',
          textos: [
            'Como Gestor você pode acompanhar os resultados do mapeamento comportamental.',
          ],
          cor: 'success',
          icone: 'thumbs_up_down',
          link: '/monitoramento/mapeamento/comportamental',
          dataInicial: this.inicioComportamental,
          dataFinal: this.mapeamento.fimPerComportComissao,
        },
        {
          visibilidade: true,
          titulo: 'Mapeamento técnico (perspectiva responsabilidades)',
          textos: [
            'Como Gestor você pode acompanhar os resultados do mapeamento técnico.',
          ],
          cor: 'secondary',
          icone: 'recent_actors',
          link: '/monitoramento/mapeamento/responsabilidade',
          dataInicial: this.mapeamento.inicioPerRespGestor,
          dataFinal: this.mapeamento.fimPerRespConsol,
        },
      ];
    },
  },

  updated() {
    if (!this.acesso) {
      this.$router.push('/403');
    }
  },
};
</script>
